<p-card>
  <div>
    <!--<div class="p-col-12 p-field">
      <div [innerHTML]="getState(notificationTo.state)"></div>
    </div>
    <div class="p-col-12">
      <table style="width: 100%;">
        <tr>
          <td>Para:</td>
          <td>{{notificationTo.mails}}</td>
        </tr>
        <tr>
          <td>Nº de veces abierto:</td>
          <td>{{notificationTo.times_open? notificationTo.times_open: "0"}}</td>
        </tr>
        <tr>
          <td>Última fecha abierto:</td>
          <td>{{notificationTo.last_time_opened? notificationTo.last_time_opened: "Sin abrir."}}</td>
        </tr>
      </table>

    </div>-->
    <div class="header-info p-col-12  p-grid">
      <div  class="p-col-3" [innerHTML]="getState(notificationTo.state)"></div>
      <div class="p-col-12 p-grid">
        <div class="p-col-4">Para: </div>
        <div class="p-col-8">{{notificationTo.mails}}</div>
        <div class="p-col-4">Nº de veces abierto: </div>
        <div class="p-col-8">{{notificationTo.times_open? notificationTo.times_open: "0"}}</div>
        <div class="p-col-4">Última fecha abierto: </div>
        <div class="p-col-8">{{notificationTo.last_time_opened? (notificationTo.last_time_opened | date:'dd/MM/yyyy HH:mm:ss'): "Sin abrir."}}</div>
      </div>
    </div>
    <!--<div class="p-col-12 p-field" *ngIf="notificationTo.text != null && notificationTo.text != ''">
      <label for="error">Error</label>
      <textarea name="error" id="error" cols="30" rows="10" readonly>{{notificationTo.text}}</textarea>
    </div>-->
    <div class="p-col-12" *ngIf="notificationTo.text != null && notificationTo.text != ''">
      <!--<label for="error">Error</label>-->
      <p-message name="error" severity="error" text="{{notificationTo.text}}" class="p-d-block"></p-message>
    </div>
    <div class="p-col-12" *ngIf="notificationTo.text == null || notificationTo.text == ''">
      <p-table [value]="notificationStats">
        <ng-template pTemplate="header">
          <tr>
            <th width="90">Tipo</th>
            <th>Descripción</th>
            <th width="90" style="text-align: center">Nº veces abierto</th>
            <th width="120" style="text-align: center">Primera apertura</th>
            <th width="120" style="text-align: center">Última apertura</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-notificationStat>
          <tr>
            <td>{{(notificationStat.type=='attachment'?'Adjunto':'Enlace')}}</td>
            <td *ngIf="notificationStat.type=='attachment'">{{notificationStat.notificationAttachment.attachment.description}}</td>
            <td *ngIf="notificationStat.type=='link'">{{notificationStat.value}}</td>
            <td width="90" style="text-align: center">{{notificationStat.times_open}}</td>
            <td style="text-align: center">{{notificationStat.first_time_opened | date: 'dd/MM/yyyy HH:mm'}}</td>
            <td style="text-align: center">{{notificationStat.last_time_opened | date: 'dd/MM/yyyy HH:mm'}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="5">
              No se encontraron datos
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-card>
